<template>
  <div class="cooperationInfoCell">
    <div class="flex">
        <el-tooltip :content="row[column.key]" class="item" effect="dark" placement="top">
            <p class="title">
                <span v-if="column.isKs">昵称：</span>
                <span>{{ row[column.key] }}</span>
            </p>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" placement="top"  v-if="!column.isKs">
            <div slot="content" class="content">
                <span>{{ column.notes }}</span><span class="ml-10">{{ row[column.copy_id] }}</span>
                <img src="@/assets/public/copy-icon.png" alt="" @click="copy(row[column.copy_id])">
            </div>
            <span class="ID-sign yx-color-primary">ID</span>
        </el-tooltip>
    </div>
    <div class="fz-13" v-if="column.key === 'item_name'">
        <span class="mr-6">{{column.isKs ? '账号：' : '电话'}}</span>
        <span>{{ column.isKs ? row.item_id  : row.phone }}</span>
    </div>
    <div :class="['fz-13', row.cooperation_type == '2' ? 'seller' : 'daRen']"  v-if="column.key === 'item_name'">
        {{ row.cooperation_type == '2' ? '商家' : '团长' }}
    </div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin],
  methods: {
      copy(value) {
            var inputTest = document.createElement("textarea");
            inputTest.value = value;
            document.body.appendChild(inputTest);
            inputTest.select();
            document.execCommand("Copy");
            inputTest.className = "oInput";
            inputTest.style.display = "none";
            this.$message.success("复制成功");
            document.body.removeChild(inputTest);
        }
  }
}
</script>
<style lang="less" scoped>
.title{
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.shop_img {
    width: 40px;
    height: 40px;
    border-radius: 5px;
}
.ID-sign{
    padding: 0px 4px;
    margin-left: 3px;
    border-radius: 2px;
    background-color: @color-parachrome;
    cursor: default;
}
.content {
    display: flex;
    align-items: center;
    img {
        margin-left: 8px;
        width: 16px;
        height: 16px;
        cursor: pointer;
    }
}
.daRen, .seller {
    padding: 0px 4px;
    display: inline-block;
    line-height: 18px;
    border-radius: 2px;
}
.daRen {
    background-color: #E9F1FF;
    color: @color-primary;
}
.seller {
    background-color: #f6f5fc;
    color: #7052ff;
}
</style>